import type { TenantsDto } from "./api/types.ts";
import { createContext, useContext } from "react";

/**
 * The workspace's tenants, region and consent, from the startup `/bff/tenants` answer. Not to be confused with
 * `TenantContext`, the tenant a module picked for its requests.
 */
export interface TenantsContextType {
    tenants: TenantsDto | null;
    refetchTenants: () => Promise<void>;
}

const TenantsContext = createContext<TenantsContextType | null>(null);

export const TenantsProvider = TenantsContext.Provider;

export function useTenants(): TenantsContextType {
    const context = useContext(TenantsContext);

    if (!context) {
        throw new Error("useTenants must be used within a TenantsProvider");
    }

    return context;
}
